import { CSSProperties } from "react";

export const getItemStyle = (draggableStyle: CSSProperties | undefined, background: string): CSSProperties => ({
  userSelect: "none",
  background,
  ...draggableStyle,
});

export function swapElements<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  if (removed !== undefined) {
    result.splice(endIndex, 0, removed);
  }

  return result;
}
